export default __webpack_public_path__ + "static/media/testimonial_brhlova.6cf07623.jpg";